module.exports = __webpack_public_path__ + "img/chevron_white_left_32px@2x.ad24dcf8.png";